import React, { useState, useMemo, useEffect, useRef } from "react";
import Table from "rc-app/components/Table";
import { getVrSessionList } from "rc-app/api/vrSessionActionsApi.js";
import { useDesktopMode } from "rc-app/hooks/useDesktopMode";
import DesktopModePrompt from "rc-app/components/DesktopModePrompt";
import { getProjectById } from "rc-app/api/projectActionsApi";
import {
  getAgentById,
  getAgentCustomers,
  getAgentProfile,
} from "rc-app/api/agentActionsApi";
import { toTitleCase } from "rc-app/utils";
import Icon from "rc-app/components/Icons";
import { MdAccessTime, MdAvTimer } from "react-icons/md";
import { getDigitalTwinById } from "rc-app/api/digitalTwinActionsAPi";
import NewMap from "rc-app/components/NewMap";
import { useNavigate } from "react-router-dom";
import {
  handleDownloadAgents,
  handleDownloadProjects,
} from "./downloadFunctions";
import {
  getClientAdminByEmailId,
  getClientManagerByEmailId,
} from "rc-app/api/systemBusinessAdminActionApi";
import UserService from "rc-app/services/UserService";

const ClientAnalytics = () => {
  const navigate = useNavigate();
  const dateInputRef = useRef(null);
  const filterRef = useRef<HTMLDivElement>(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showQuickFilter, setShowQuickFilter] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [showCustomDates, setShowCustomDates] = useState(false);
  const [projectSortBy, setProjectSortBy] = useState("name");
  const [agentSortBy, setAgentSortBy] = useState("id");

  const [agencyId, setAgencyId] = useState();
  const [agentId, setAgentId] = useState();
  const [clientAdminId, setClientAdminId] = useState();
  const [clientManagerId, setClientManagerId] = useState();

  const [projectLocations, setProjectLocations] = useState<any[]>([]);

  // VR Session states
  const [vrSessions, setVrSessions] = useState<any[]>([]);
  const [enrichedSessions, setEnrichedSessions] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [projectsCache, setProjectsCache] = useState<Map<string, any>>(
    new Map(),
  );
  const [agentsCache, setAgentsCache] = useState<Map<string, any>>(new Map());

  const [resolvedAgentsData, setResolvedAgentsData] = useState<any[]>([]);

  const [showProjectSort, setShowProjectSort] = useState(false);
  const [showAgentSort, setShowAgentSort] = useState(false);

  const [projectSearchQuery, setProjectSearchQuery] = useState("");
  const [agentSearchQuery, setAgentSearchQuery] = useState("");

  const { showPrompt, accept, dismiss } = useDesktopMode();

  // Add these new refs after the existing refs (around line 16):
  const projectSortRef = useRef<HTMLDivElement>(null);
  const agentSortRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (UserService.hasRole("agency_business_admin")) {
      getClientManagerByEmailId(UserService.getUseremail()).then((res) => {
        setAgencyId(res.agency_business_admin?.agency_id);
        setClientManagerId(res.agency_business_admin?._id);
        console.log("dgdgdg", res.agency_business_admin?.agency_id);
      });
    }
    if (UserService.hasRole("agency_system_admin")) {
      getClientAdminByEmailId(UserService.getUseremail()).then((res) => {
        setAgencyId(res.agency_system_admin?.agency_id);
        setClientAdminId(res.agency_system_admin?.id);
      });
    }

    if (UserService.hasRole("agent")) {
      getAgentProfile(UserService.getUseremail())
        .then((res) => { 
          setAgencyId(res?.agent?.agency["id"]);
          setAgentId(res?.agent?._id);
          // fetchProjectList(res?.agent?.agency["id"]);
          console.log("agency_system_admin 6", res, agentId);
        })
        .catch((error) => {
          console.error("Error fetching client manager:", error);
          console.error("Error response:", error.response);
          setIsLoading(false);
        });
    }
  }, []);

  const fetchProjectLocations = async () => {
    const locations: any[] = [];
    const processedProjects = new Set();

    for (const session of enrichedSessions) {
      if (session.digital_twin_ids && session.digital_twin_ids.length > 0) {
        const projectId = session.project_id;

        if (processedProjects.has(projectId)) {
          continue;
        }
        processedProjects.add(projectId);

        for (const twinId of session.digital_twin_ids) {
          if (!twinId || twinId === "") {
            continue;
          }

          try {
            const digitalTwin = await getDigitalTwinById(twinId);

            if (
              digitalTwin?.success &&
              digitalTwin?.digital_twin?.geo_location
            ) {
              const location = {
                projectName:
                  session.projectDetails?.project_name || "Unknown Project",
                geo_location: digitalTwin.digital_twin.geo_location,
                twinId: twinId,
              };
              locations.push(location);
            } else {
              console.log(" No geo_location in response");
            }
          } catch (error) {
            console.error(` Error fetching digital twin ${twinId}:`, error);
          }
        }
      } else {
        console.log(" No digital_twin_ids for this session");
      }
    }

    console.log("🎯 Final locations array:", locations);
    console.log("🎯 Total locations found:", locations.length);
    setProjectLocations(locations);
  };

  console.log(
    "projectLocations",
    projectsCache,
    projectLocations,
    enrichedSessions,
  );

  useEffect(() => {
    if (enrichedSessions.length > 0) {
      fetchProjectLocations();
    }
  }, [enrichedSessions]);

  // Fetch VR Sessions with date filter
  const fetchVrSessions = async () => {
    setIsLoading(true);
    try {
      // Logic: Send dates if they exist, regardless of "Custom" or not
      const startDate = fromDate || null;
      const endDate = toDate || null;

      const response = await getVrSessionList(
      agencyId,
      0,
      100,
      startDate,
      endDate,
      agentId,           
      clientAdminId,     
      clientManagerId,   
    );
      if (response.success) {
        const sessions = response.sessions || [];
        setVrSessions(sessions);
        console.log("sessionjj", sessions);

        await enrichSessionsData(sessions);
      }
    } catch (error) {
      console.error("Error fetching VR sessions:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Initial fetch without dates
  // useEffect(() => {
  //   fetchVrSessions();
  // }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target as Node)
      ) {
        setShowQuickFilter(false);
      }
      if (
        projectSortRef.current &&
        !projectSortRef.current.contains(event.target as Node)
      ) {
        setShowProjectSort(false);
      }
      if (
        agentSortRef.current &&
        !agentSortRef.current.contains(event.target as Node)
      ) {
        setShowAgentSort(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    handleQuickFilter("All");
  }, []);

  useEffect(() => {
    if (agencyId) {
      fetchVrSessions();
    }
  }, [agencyId]);

  // Initial fetch when required IDs are available
  useEffect(() => {
    const hasRequiredIds =
      agencyId &&
      (UserService.hasRole("agent") ? agentId : true) &&
      (UserService.hasRole("agency_system_admin") ? clientAdminId : true) &&
      (UserService.hasRole("agency_business_admin") ? clientManagerId : true);

    if (hasRequiredIds) {
      fetchVrSessions();
    }
  }, [agencyId, agentId, clientAdminId, clientManagerId]);

  // Re-fetch when date filters change
  useEffect(() => {
    if (agencyId && (fromDate || toDate || selectedFilter !== "All")) {
      fetchVrSessions();
    }
  }, [fromDate, toDate, selectedFilter]);

  useEffect(() => {
    console.log("AgentIdfg", fromDate, toDate, selectedFilter);
  }, [fromDate, toDate, selectedFilter]);

  const enrichSessionsData = async (sessions: any[]) => {
    const newProjectsCache = new Map(projectsCache);
    const newAgentsCache = new Map(agentsCache);

    const enrichedData = await Promise.all(
      sessions.map(async (session) => {
        let projectDetails = null;
        let agentDetails = null;

        if (session.project_id) {
          if (newProjectsCache.has(session.project_id)) {
            projectDetails = newProjectsCache.get(session.project_id);
            console.log("📦 Using cached project:", projectDetails); // Add this log
          } else {
            try {
              const projectRes = await getProjectById(session.project_id);
              console.log("🌐 Fetched project from API:", projectRes); // Add this log
              if (projectRes?.success) {
                projectDetails = projectRes.project;
                console.log("🌐 Fetched project from API:", projectDetails);
                newProjectsCache.set(session.project_id, projectDetails);
              }
            } catch (error) {
              console.error(
                `Error fetching project ${session.project_id}:`,
                error,
              );
            }
          }
        }

        if (session.agent_id && session.agent_id.length > 0) {
          const agentId = session.agent_id[0];
          if (newAgentsCache.has(agentId)) {
            agentDetails = newAgentsCache.get(agentId);
          } else {
            try {
              const agentRes = await getAgentById(agentId);
              if (agentRes?.success) {
                agentDetails = agentRes.agent;
                console.log("📦 Using cached agent:", agentDetails);
                newAgentsCache.set(agentId, agentDetails);
              }
            } catch (error) {
              console.error(`Error fetching agent ${agentId}:`, error);
            }
          }
        }

        return {
          ...session,
          digital_twin_ids: projectDetails.digital_twin_ids,
          projectDetails,
          agentDetails,
        };
      }),
    );

    console.log("enrichedData", enrichedData);

    setProjectsCache(newProjectsCache);
    setAgentsCache(newAgentsCache);
    setEnrichedSessions(enrichedData);
  };

  const handleQuickFilter = (option: string) => {
    setSelectedFilter(option);
    setShowQuickFilter(false);

    if (option === "Custom") {
      setShowCustomDates(true);
      return; // Wait for user to pick dates
    }

    setShowCustomDates(false);

    if (option === "All") {
      // Reset to no filter - fetch all data
      setFromDate("");
      setToDate("");
      return;
    }

    const today = new Date();
    let from = new Date();

    switch (option) {
      case "Daily":
        from = new Date(today);
        break;
      case "Today":
        from = new Date(today);
        break;
      case "Yesterday":
        from = new Date(today);
        from.setDate(from.getDate() - 1);
        break;
      case "Last Week":
        from = new Date(today);
        from.setDate(from.getDate() - 7);
        break;
      case "Last Month":
        from = new Date(today);
        from.setMonth(from.getMonth() - 1);
        break;
      default:
        from = new Date(today);
        break;
    }

    const fromStr = from.toISOString().split("T")[0];
    const toStr = today.toISOString().split("T")[0];
    setFromDate(fromStr);
    setToDate(toStr);
  };

  // Format date for display (MM/DD/YYYY)
  const formatDisplayDate = (dateStr: string) => {
    if (!dateStr) return "MM/DD/YYYY";
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // Calculate real metrics from VR sessions
  // Calculate real metrics from VR sessions
  const calculatedMetrics = useMemo(() => {
    const totalSessions = vrSessions.length;
    const totalTimeSpent = vrSessions.reduce(
      (sum, s) => sum + (s.total_duration || 0),
      0,
    );

    // Count unique customers (will work when customer_id has valid values)
    const uniqueCustomers = new Set(
      vrSessions
        .map((s) => s.customer_id)
        .filter((id) => id !== null && id !== undefined && id !== ""),
    ).size;

    const vrToursCompleted = vrSessions.filter(
      (s) => s.used_vr === true,
    ).length;
    const tours2DCompleted = vrSessions.filter(
      (s) => s.used_vr === false,
    ).length;

    const sessionsWithDuration = vrSessions.filter(
      (s) => s.total_duration && s.total_duration > 0,
    );
    const avgTimePerSession =
      sessionsWithDuration.length > 0
        ? (totalTimeSpent / sessionsWithDuration.length).toFixed(1)
        : 0;

    // Calculate total agents and active agents
    const allAgents = new Set();
    const activeAgents = new Set();

    vrSessions.forEach((session) => {
      if (session.agent_id && session.agent_id.length > 0) {
        const agentId = session.agent_id[0];
        if (agentId && agentId !== null && agentId !== "") {
          allAgents.add(agentId);
          activeAgents.add(agentId);
        }
      }
    });

    return {
      totalTimeSpent: totalTimeSpent.toFixed(0),
      totalCustomerViews: totalSessions,
      uniqueCustomerViews: uniqueCustomers,
      vrToursCompleted,
      tours2DCompleted,
      avgTimePerSession,
      totalAgents: allAgents.size,
      activeAgents: activeAgents.size,
    };
  }, [vrSessions]);

  const metricsData = [
    {
      label: "Total Client Views",
      value: calculatedMetrics.totalCustomerViews,
      change: "28.4%",
      trend: "down",
      period: "Down from yesterday",
      icon: <Icon name="ic-eye" className="w-4 h-4" />,
    },
    {
      label: "Unique Client Views",
      value: calculatedMetrics.uniqueCustomerViews,
      change: "8.8%",
      trend: "up",
      period: "Up from yesterday",
      icon: <Icon name="ic-empty-star" className="w-4 h-4" />,
    },
    {
      label: "Total Agents",
      value: calculatedMetrics.totalAgents,
      change: "8.8%",
      trend: "up",
      period: "Up from yesterday",
      icon: <Icon name="ic-multi-user" className="w-4 h-4" />,
    },
    {
      label: "Active Agents",
      value: calculatedMetrics.activeAgents,
      change: "8.8%",
      trend: "up",
      period: "Up from yesterday",
      icon: <Icon name="ic-active-user" className="w-4 h-4" />,
    },
    {
      label: "2D Tours Completed",
      value: calculatedMetrics.tours2DCompleted,
      change: "5.2%",
      trend: "up",
      period: "Up from yesterday",
      icon: <Icon name="ic-2D" className="w-4 h-4" />,
    },
    {
      label: "VR Tours Completed",
      value: calculatedMetrics.vrToursCompleted,
      change: "8.8%",
      trend: "up",
      period: "Up from yesterday",
      icon: <Icon name="ic-vr" className="w-4 h-4" />,
    },
    {
      label: "Total Time Spent",
      value: `${calculatedMetrics.totalTimeSpent}m`,
      change: "8.8%",
      trend: "up",
      period: "Up from yesterday",
      icon: <MdAccessTime className="w-4 h-4" />,
    },
    {
      label: "Avg. Time Per Session",
      value: `${calculatedMetrics.avgTimePerSession}m`,
      change: "10.8%",
      trend: "down",
      period: "Up from yesterday",
      icon: <MdAvTimer className="w-4 h-4" />,
    },
  ];

  // Group sessions by project for projects table
  const projectsData = useMemo(() => {
    const projectMap = new Map();

    enrichedSessions.forEach((session) => {
      if (session.projectDetails) {
        const projectId = session.project_id;
        if (!projectMap.has(projectId)) {
          projectMap.set(projectId, {
            name: session.projectDetails.project_name,
            totalViews: 0,
            uniqueClients: new Set(),
            activeAgents: new Set(),
            tours2D: 0,
            toursVR: 0,
          });
        }

        const project = projectMap.get(projectId);

        // Total Client Views = total sessions for this project
        project.totalViews++;

        // Unique Client Views = unique customers who viewed this project
        // Only add if customer_id has a valid value
        if (
          session.customer_id &&
          session.customer_id !== null &&
          session.customer_id !== ""
        ) {
          project.uniqueClients.add(session.customer_id);
        }

        // Active Agents = unique agents who had sessions for this project
        if (session.agent_id && session.agent_id.length > 0) {
          const agentId = session.agent_id[0];
          if (agentId && agentId !== null && agentId !== "") {
            project.activeAgents.add(agentId);
          }
        }

        // 2D Tours = sessions where used_vr is false
        // VR Tours = sessions where used_vr is true
        if (session.used_vr === true) {
          project.toursVR++;
        } else if (session.used_vr === false) {
          project.tours2D++;
        }
      }
    });

    return Array.from(projectMap.values()).map((p) => ({
      name: p.name,
      totalViews: p.totalViews,
      uniqueViews: p.uniqueClients.size,
      activeAgents: p.activeAgents.size,
      tours2D: p.tours2D,
      toursVR: p.toursVR,
    }));
  }, [enrichedSessions]);

  // Format date for Last Active (MM/DD/YYYY | HH:MM)
  const formatLastActive = (dateStr: string) => {
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} | ${hours}:${minutes}`;
  };

  // Group sessions by agent for agents table
  const agentsData = useMemo(() => {
    type AgentEntry = {
      id: string;
      email: string;
      lastActive: string;
      totalSessions: number;
      customers: Set<string>;
      customerFirstSessions: Map<string, Date>;
      tours2D: number;
      vrTours: number;
    };
    const agentMap = new Map<string, AgentEntry>();

    enrichedSessions.forEach((session) => {
      if (
        session.agentDetails &&
        session.agent_id &&
        session.agent_id.length > 0
      ) {
        const agentId = session.agent_id[0];
        if (!agentMap.has(agentId)) {
          agentMap.set(agentId, {
            id: session.agentDetails.agent_id,
            email: session.agentDetails.email_id, // Store email for API call
            lastActive: formatLastActive(session.timestamp),
            totalSessions: 0,
            customers: new Set(),
            customerFirstSessions: new Map<string, Date>(),
            tours2D: 0,
            vrTours: 0,
          });
        }

        const agent = agentMap.get(agentId)!;
        agent.totalSessions++;

        // Update last active to most recent timestamp
        const currentTimestamp = new Date(session.timestamp);
        const existingTimestamp = new Date(agent.lastActive);
        if (currentTimestamp > existingTimestamp) {
          agent.lastActive = currentTimestamp.toLocaleString();
        }

        // Track customers and their first session
        if (
          session.customer_id &&
          session.customer_id !== null &&
          session.customer_id !== ""
        ) {
          agent.customers.add(session.customer_id);

          // Track first session timestamp for each customer
          const sessionTimestamp = new Date(session.timestamp);
          if (!agent.customerFirstSessions.has(session.customer_id)) {
            agent.customerFirstSessions.set(
              session.customer_id,
              sessionTimestamp,
            );
          } else {
            // Update if this session is earlier
            const existingFirst = agent.customerFirstSessions.get(
              session.customer_id,
            )!;
            if (sessionTimestamp < existingFirst) {
              agent.customerFirstSessions.set(
                session.customer_id,
                sessionTimestamp,
              );
            }
          }
        }

        // Count tours
        if (session.used_vr === true) {
          agent.vrTours++;
        } else if (session.used_vr === false) {
          agent.tours2D++;
        }
      }
    });

    // Fetch total customers for each agent
    const agentsWithCustomers = Promise.all(
      Array.from(agentMap.values()).map(async (a) => {
        // Calculate newly onboarded clients based on selected date range
        let newlyOnboarded = 0;

        if (fromDate && toDate) {
          const startDateObj = new Date(fromDate);
          startDateObj.setHours(0, 0, 0, 0);

          const endDateObj = new Date(toDate);
          endDateObj.setHours(23, 59, 59, 999);

          newlyOnboarded = Array.from(a.customerFirstSessions.entries()).filter(
            ([customerId, firstSessionDate]) => {
              return (
                firstSessionDate >= startDateObj &&
                firstSessionDate <= endDateObj
              );
            },
          ).length;
        } else {
          newlyOnboarded = a.customerFirstSessions.size;
        }

        // Fetch total customers from API
        let totalCustomers = 0;
        try {
          if (!a.email) {
            totalCustomers = 0;
          } else {
            const customersResponse = await getAgentCustomers(a.email);
            if (
              customersResponse?.success === true &&
              Array.isArray(customersResponse?.re_customer_list)
            ) {
              totalCustomers = customersResponse.re_customer_list.length;
            } else if (Array.isArray(customersResponse?.customers)) {
              totalCustomers = customersResponse.customers.length;
            } else if (Array.isArray(customersResponse?.data)) {
              totalCustomers = customersResponse.data.length;
            } else if (Array.isArray(customersResponse)) {
              totalCustomers = customersResponse.length;
            } else {
              totalCustomers = 0;
            }
          }
        } catch (error) {
          console.error(` Error fetching customers for agent ${a.id}:`, error);
          totalCustomers = 0;
        }

        console.log(
          "📊 Final totalCustomers for agent",
          a.id,
          ":",
          totalCustomers,
        );

        return {
          id: a.id,
          lastActive: a.lastActive,
          totalClientViews: a.totalSessions,
          totalClients: totalCustomers, // From API
          uniqueClients: a.customers.size, // From sessions
          newlyOnboarded: newlyOnboarded,
          tours2D: a.tours2D,
          vrTours: a.vrTours,
        };
      }),
    );

    return agentsWithCustomers;
  }, [enrichedSessions, fromDate, toDate]);

  useEffect(() => {
    agentsData.then((data) => setResolvedAgentsData(data));
  }, [agentsData]);
  // Add this inside the sortedProjects useMemo (around line 577):
  const sortedProjects = useMemo(() => {
    console.log("🔵 sortedProjects - projectSortBy:", projectSortBy);
    console.log("🔵 sortedProjects - projectsData:", projectsData);

    const sorted = [...projectsData].sort((a: any, b: any) => {
      const aVal = a[projectSortBy];
      const bVal = b[projectSortBy];

      // Always sort ASCENDING for consistency
      if (typeof aVal === "number" && typeof bVal === "number") {
        return aVal - bVal; // Changed from bVal - aVal
      }
      return String(aVal).localeCompare(String(bVal));
    });

    return sorted;
  }, [projectsData, projectSortBy]);

  const sortedAgents = useMemo(() => {
    const sorted = [...resolvedAgentsData].sort((a: any, b: any) => {
      const aVal = a[agentSortBy];
      const bVal = b[agentSortBy];

      // Always sort ASCENDING for consistency
      if (typeof aVal === "number" && typeof bVal === "number") {
        return aVal - bVal; // Changed from bVal - aVal
      }
      return String(aVal).localeCompare(String(bVal));
    });

    return sorted;
  }, [resolvedAgentsData, agentSortBy]);

  const handleProjectSort = (sortKey: string, label: string) => {
    setProjectSortBy(sortKey);
    setShowProjectSort(false);
  };

  const handleAgentSort = (sortKey: string, label: string) => {
    setAgentSortBy(sortKey);
    setShowAgentSort(false);
  };

  const getProjectSortLabel = () => {
    const labels: Record<string, string> = {
      name: "Project Name",
      totalViews: "Total Views",
      uniqueViews: "Unique Views",
      activeAgents: "Active Agents",
    };
    return labels[projectSortBy] || "Project Name";
  };

  const getAgentSortLabel = () => {
    const labels: Record<string, string> = {
      id: "Agent ID",
      lastActive: "Last Active",
      totalClients: "Total Clients",
      totalClientViews: "Total Client Views",
      newlyOnboarded: "Newly Onboarded",
      tours2D: "2D Tours",
      vrTours: "VR Tours",
    };
    return labels[agentSortBy] || "Agent ID";
  };

  const projectColumns = [
    "Project Name",
    "Total Client Views",
    "Unique Client Views",
    "Active Agents",
    "2D Tours Completed",
    "VR Tours Completed",
  ];
  const agentColumns = [
    "Agent ID",
    "Last Active",
    "Total Clients",
    "Total Client Views",
    // "Unique Clients",
    "Newly Onboarded Clients",
    "2D Tours Completed",
    "VR Tours Completed",
  ];
  const leadsColumns = [
    "Lead ID",
    "Lead Name",
    "Last Active",
    "2D Tours Completed",
    "VR Tours Completed",
  ];

  const renderProjectRow = (project: any, index: number) => (
    <tr
      key={index}
      className="bg-[#161F28] hover:bg-[#35495E] border border-[#374B5E]  transition-colors text-[#F4F5F7]"
    >
      <td className="px-4 py-3 text-sm font-medium">
        {toTitleCase(project.name)}
      </td>
      <td className="px-4 py-3 text-sm">{project.totalViews}</td>
      <td className="px-4 py-3 text-sm">{project.uniqueViews}</td>
      <td className="px-4 py-3 text-sm">{project.activeAgents}</td>
      <td className="px-4 py-3 text-sm">{project.tours2D}</td>
      <td className="px-4 py-3 text-sm">{project.toursVR}</td>
    </tr>
  );

  const renderAgentRow = (agent: any, index: number) => (
    <tr
      key={index}
      className="bg-[#161F28] hover:bg-[#35495E] border border-[#374B5E] transition-colors text-[#F4F5F7]"
    >
      <td className="px-4 py-3 text-sm font-medium">{agent.id}</td>
      <td className="px-4 py-3 text-sm">{agent.lastActive}</td>
      <td className="px-4 py-3 text-sm">{agent.totalClients}</td>
      <td className="px-4 py-3 text-sm">{agent.totalClientViews}</td>
      {/* <td className="px-4 py-3 text-sm">{agent.uniqueClients}</td> */}
      <td className="px-4 py-3 text-sm">{agent.newlyOnboarded}</td>
      <td className="px-4 py-3 text-sm">{agent.tours2D}</td>
      <td className="px-4 py-3 text-sm">{agent.vrTours}</td>
    </tr>
  );
  const renderLeadRow = (agent: any, index: number) => (
    <tr
      key={index}
      className="bg-[#161F28] hover:bg-[#35495E] border border-[#374B5E] transition-colors text-[#F4F5F7]"
    >
      <td className="px-4 py-3 text-sm font-medium">{agent.id}</td>
      <td className="px-4 py-3 text-sm">Chandrashekhar Reddy</td>
      <td className="px-4 py-3 text-sm">{agent.lastActive}</td>
      <td className="px-4 py-3 text-sm">{agent.tours2D}</td>
      <td className="px-4 py-3 text-sm">{agent.vrTours}</td>
    </tr>
  );

  const handleOpenPicker = () => {
    // .showPicker() is the modern way to trigger the native calendar
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };

  // Filter projects by search query
  const filteredProjects = useMemo(() => {
    if (!projectSearchQuery.trim()) {
      return sortedProjects;
    }

    return sortedProjects.filter((project) =>
      project.name.toLowerCase().includes(projectSearchQuery.toLowerCase()),
    );
  }, [sortedProjects, projectSearchQuery]);

  // Filter agents by search query
  const filteredAgents = useMemo(() => {
    if (!agentSearchQuery.trim()) {
      return sortedAgents;
    }

    return sortedAgents.filter((agent) =>
      agent.id.toLowerCase().includes(agentSearchQuery.toLowerCase()),
    );
  }, [sortedAgents, agentSearchQuery]);

  if (showPrompt) {
    return (
      <DesktopModePrompt
        message="This page contains analytics dashboards, data tables, and maps that are best viewed in desktop mode. Switch to desktop view for the best experience."
        onAccept={accept}
        onGoBack={() => { dismiss(); navigate("/"); }}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1C2C3A] to-[#1E4F52] p-6">
      <div className="mb-6 flex items-center justify-between">
        <button
          onClick={() => {
            navigate("/");
          }}
          className=" text-white flex items-center gap-2 hover:text-[#008564] transition-colors"
        >
          {`< My Analytics`}
        </button>
      </div>

      {isLoading ? (
        <div className="flex flex-col items-center justify-center min-h-[400px]">
          <div className="w-16 h-16 border-4 border-[#008564] border-t-transparent rounded-full animate-spin"></div>
          <p className="text-white mt-4 text-lg">Loading analytics...</p>
        </div>
      ) : (
        <>
          {!UserService.hasRole("agent") && (
            <div className="flex flex-col p-4 gap-3 mb-6 bg-[#161F28] rounded-lg">
              <div className="flex items-center justify-between">
                <h2 className="text-white text-lg mb-4">Overall Analytics</h2>
                <div className="flex items-center gap-3">
                  {/* Show date inputs only when Custom is selected */}

                  <div className="flex gap-2 p-2 border border-[#2E4051] rounded-lg">
                    <div className="relative ">
                      <button
                        onClick={handleOpenPicker}
                        className="bg-[#2E4051] text-white px-4 py-2 rounded-lg flex items-center gap-4 border border-[#3A4F5E] hover:bg-[#35495E] transition-colors"
                      >
                        <span className="text-sm">
                          From - {formatDisplayDate(fromDate)}
                        </span>
                        <Icon
                          onClick={showCustomDates && handleOpenPicker}
                          name="ic-down"
                          className="w-4 h-4 text-white cursor-pointer "
                        />
                      </button>
                      {showCustomDates && (
                        <>
                          <input
                            ref={dateInputRef}
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            className="absolute inset-0 opacity-0 "
                          />
                        </>
                      )}
                    </div>

                    <div className="relative">
                      <button className="bg-[#2E4051] text-white px-4 py-2 rounded-lg flex items-center gap-4 border border-[#3A4F5E] hover:bg-[#35495E] transition-colors">
                        <span className="text-sm">
                          Till - {formatDisplayDate(toDate)}
                        </span>
                        <Icon
                          onClick={showCustomDates && handleOpenPicker}
                          name="ic-down"
                          className="w-4 h-4 text-white cursor-pointer "
                        />
                      </button>
                      {showCustomDates && (
                        <input
                          type="date"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                          className="absolute inset-0 opacity-0 cursor-pointer"
                        />
                      )}
                    </div>
                  </div>
                  {/* Filter Dropdown */}
                  <div
                    className="relative items-center justify-center"
                    ref={filterRef}
                  >
                    <button
                      onClick={() => setShowQuickFilter(!showQuickFilter)}
                      className="bg-[#008564] text-white px-6 py-2.5 rounded-lg flex items-center gap-4 hover:opacity-90 transition-colors"
                    >
                      <span className="text-sm font-medium">
                        {selectedFilter}
                      </span>
                      <Icon name="ic-down" className="w-4 h-4 text-white " />
                    </button>

                    {showQuickFilter && (
                      <div className="absolute right-0 mt-2 w-40 bg-[#2E4051] rounded shadow-lg border border-[#3A4F5E] z-10">
                        <button
                          onClick={() => handleQuickFilter("All")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          All
                        </button>
                        <button
                          onClick={() => handleQuickFilter("Daily")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Daily
                        </button>
                        <button
                          onClick={() => handleQuickFilter("Today")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Today
                        </button>
                        <button
                          onClick={() => handleQuickFilter("Yesterday")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Yesterday
                        </button>
                        <button
                          onClick={() => handleQuickFilter("Last Week")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Last Week
                        </button>
                        <button
                          onClick={() => handleQuickFilter("Last Month")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Last Month
                        </button>
                        <button
                          onClick={() => handleQuickFilter("Custom")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Custom
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-4 gap-4">
                {metricsData.map((metric, index) => (
                  <div
                    key={index}
                    className={`bg-[#2E4051] p-4 rounded-lg border-l-8 ${
                      metric.trend === "up"
                        ? "border-[#008564]"
                        : "border-[#ED5562]"
                    }`}
                  >
                    <div className="flex gap-2 text-[#889DB2] text-xs mb-1 items-center">
                      {metric?.icon}
                      {metric.label}
                    </div>
                    <div className="text-white text-2xl font-bold mb-1">
                      {metric.value}
                    </div>
                    <div
                      className={`flex gap-2 text-sm text-white items-center `}
                    >
                      <span
                        className={`flex gap-1 items-center justify-center text-white text-xs w-[20%] py-1 ${
                          metric.trend === "up"
                            ? "bg-[#008564]"
                            : "bg-[#E74C3C]"
                        }`}
                      >
                        {metric.trend === "up" ? (
                          <Icon name="ic-up-arrow-green" className="w-3 h-3" />
                        ) : (
                          <Icon name="ic-down-arrow-red" className="w-3 h-3" />
                        )}{" "}
                        {metric.change}
                      </span>{" "}
                      <span className="text-[#889DB2] text-xs">
                        {metric.period}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="flex flex-col p-4 mb-6 bg-[#161F28] rounded-lg">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-white text-lg flex items-center gap-2">
                <Icon
                  onClick={showCustomDates && handleOpenPicker}
                  name="ic-circle-down"
                  className="w-5 h-5 text-white cursor-pointer "
                />{" "}
                Projects
              </h2>
              <div className="flex items-center gap-4">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={projectSearchQuery}
                    onChange={(e) => setProjectSearchQuery(e.target.value)}
                    className="bg-[#2E4051] text-white px-4 py-2 pl-10 rounded-lg shadow-lg text-sm focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors"
                  />
                  <Icon
                    name="ic-search"
                    className="absolute left-3 top-2.5 w-4 h-4"
                  />
                </div>
                <div className="relative" ref={projectSortRef}>
                  <button
                    onClick={() => setShowProjectSort(!showProjectSort)}
                    className="bg-[#2E4051] text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 hover:bg-[#35495E] transition-colors text-sm"
                  >
                    <span>Sort by: {getProjectSortLabel()}</span>
                    <Icon name="ic-down" className="w-4 h-4 text-white" />
                  </button>

                  {showProjectSort && (
                    <div className="absolute right-0 mt-2 w-56 bg-[#2E4051] rounded-lg shadow-lg  z-10">
                      <button
                        onClick={() =>
                          handleProjectSort("name", "Project Name")
                        }
                        className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                      >
                        Sort by: Project Name
                      </button>
                      <button
                        onClick={() =>
                          handleProjectSort("totalViews", "Total Views")
                        }
                        className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                      >
                        Sort by: Total Views
                      </button>
                      <button
                        onClick={() =>
                          handleProjectSort("uniqueViews", "Unique Views")
                        }
                        className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                      >
                        Sort by: Unique Views
                      </button>
                      <button
                        onClick={() =>
                          handleProjectSort("activeAgents", "Active Agents")
                        }
                        className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                      >
                        Sort by: Active Agents
                      </button>
                    </div>
                  )}
                </div>

                <button
                  onClick={() =>
                    handleDownloadProjects(sortedProjects, projectColumns)
                  }
                  className="flex gap-2 bg-[#008564] text-white px-4 py-2 rounded hover:opacity-90 transition-colors text-sm"
                >
                  <Icon
                    name="ic-download"
                    className="w-4 h-4 text-white cursor-pointer "
                  />{" "}
                  Download
                </button>
              </div>
            </div>
            <Table
              key={`project-table-${projectSortBy}`}
              columns={projectColumns}
              // data={sortedProjects}
              data={filteredProjects}
              renderRow={renderProjectRow}
              sortableColumns={[0, 1, 2, 3, 4, 5]}
              columnKeys={[
                "name",
                "totalViews",
                "uniqueViews",
                "activeAgents",
                "tours2D",
                "toursVR",
              ]}
            />
          </div>

          {UserService.hasRole("agent") && (
            <div className="flex flex-col p-4 mb-6 bg-[#161F28] rounded-lg">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-white text-lg flex items-center gap-2">
                  <Icon
                    name="ic-circle-down"
                    className="w-5 h-5 text-white cursor-pointer "
                  />{" "}
                  Leads
                </h2>
                <div className="flex items-center gap-4">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={agentSearchQuery}
                      onChange={(e) => setAgentSearchQuery(e.target.value)}
                      className="bg-[#2E4051] text-white px-4 py-2 pl-10 rounded-lg shadow-lg text-sm focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors"
                    />
                    <Icon
                      name="ic-search"
                      className="absolute left-3 top-2.5 w-4 h-4"
                    />
                  </div>
                  <div className="relative" ref={agentSortRef}>
                    <button
                      disabled
                      onClick={() => setShowAgentSort(!showAgentSort)}
                      className="bg-[#2E4051] text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 hover:bg-[#35495E] transition-colors text-sm"
                    >
                      {/* <span>Sort by: {getAgentSortLabel()}</span> */}
                      <span>Sort by: Leads Name</span>
                      <Icon name="ic-down" className="w-4 h-4 text-white" />
                    </button>

                    {showAgentSort && (
                      <div className=" absolute right-0 mt-2 w-56 bg-[#2E4051] rounded shadow-lg border border-[#3A4F5E] z-10">
                        <button
                          onClick={() => handleAgentSort("id", "Agent ID")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: Agent ID
                        </button>
                        <button
                          onClick={() =>
                            handleAgentSort("lastActive", "Last Active")
                          }
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: Last Active
                        </button>
                        <button
                          onClick={() =>
                            handleAgentSort("totalClients", "Total Clients")
                          }
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: Total Clients
                        </button>
                        <button
                          onClick={() =>
                            handleAgentSort(
                              "totalClientViews",
                              "Total Client Views",
                            )
                          }
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: Total Client Views
                        </button>
                        <button
                          onClick={() =>
                            handleAgentSort("newlyOnboarded", "Newly Onboarded")
                          }
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: Newly Onboarded
                        </button>
                        <button
                          onClick={() => handleAgentSort("tours2D", "2D Tours")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: 2D Tours
                        </button>
                        <button
                          onClick={() => handleAgentSort("vrTours", "VR Tours")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: VR Tours
                        </button>
                      </div>
                    )}
                  </div>

                  <button
                    onClick={() =>
                      handleDownloadAgents(sortedAgents, agentColumns)
                    }
                    className="flex gap-2  bg-[#008564] text-white px-4 py-2 rounded hover:opacity-90 transition-colors text-sm"
                  >
                    <Icon
                      name="ic-download"
                      className="w-4 h-4 text-white cursor-pointer "
                    />{" "}
                    Download
                  </button>
                </div>
              </div>
              <Table
                key={`agent-table-${agentSortBy}`}
                columns={leadsColumns}
                data={[]}
                renderRow={renderLeadRow}
                sortableColumns={[0, 1, 2, 3, 4, 5]}
                columnKeys={[
                  "id",
                  "lastActive",
                  "totalClients",
                  "totalClientViews",
                  "newlyOnboarded",
                  "tours2D",
                  "vrTours",
                ]}
              />
            </div>
          )}

          {!UserService.hasRole("agent") && (
            <div className="flex flex-col p-4 mb-6 bg-[#161F28] rounded-lg">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-white text-lg flex items-center gap-2">
                  <Icon
                    name="ic-circle-down"
                    className="w-5 h-5 text-white cursor-pointer "
                  />{" "}
                  Agents
                </h2>
                <div className="flex items-center gap-4">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={agentSearchQuery}
                      onChange={(e) => setAgentSearchQuery(e.target.value)}
                      className="bg-[#2E4051] text-white px-4 py-2 pl-10 rounded-lg shadow-lg text-sm focus:border-[#008564] focus:outline-none focus:ring-2 focus:ring-[#008564] transition-colors"
                    />
                    <Icon
                      name="ic-search"
                      className="absolute left-3 top-2.5 w-4 h-4"
                    />
                  </div>
                  <div className="relative" ref={agentSortRef}>
                    <button
                      onClick={() => setShowAgentSort(!showAgentSort)}
                      className="bg-[#2E4051] text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2 hover:bg-[#35495E] transition-colors text-sm"
                    >
                      <span>Sort by: {getAgentSortLabel()}</span>
                      <Icon name="ic-down" className="w-4 h-4 text-white" />
                    </button>

                    {showAgentSort && (
                      <div className="absolute right-0 mt-2 w-56 bg-[#2E4051] rounded shadow-lg border border-[#3A4F5E] z-10">
                        <button
                          onClick={() => handleAgentSort("id", "Agent ID")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: Agent ID
                        </button>
                        <button
                          onClick={() =>
                            handleAgentSort("lastActive", "Last Active")
                          }
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: Last Active
                        </button>
                        <button
                          onClick={() =>
                            handleAgentSort("totalClients", "Total Clients")
                          }
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: Total Clients
                        </button>
                        <button
                          onClick={() =>
                            handleAgentSort(
                              "totalClientViews",
                              "Total Client Views",
                            )
                          }
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: Total Client Views
                        </button>
                        <button
                          onClick={() =>
                            handleAgentSort("newlyOnboarded", "Newly Onboarded")
                          }
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: Newly Onboarded
                        </button>
                        <button
                          onClick={() => handleAgentSort("tours2D", "2D Tours")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: 2D Tours
                        </button>
                        <button
                          onClick={() => handleAgentSort("vrTours", "VR Tours")}
                          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-[#35495E]"
                        >
                          Sort by: VR Tours
                        </button>
                      </div>
                    )}
                  </div>

                  <button
                    onClick={() =>
                      handleDownloadAgents(sortedAgents, agentColumns)
                    }
                    className="flex gap-2  bg-[#008564] text-white px-4 py-2 rounded hover:opacity-90 transition-colors text-sm"
                  >
                    <Icon
                      name="ic-download"
                      className="w-4 h-4 text-white cursor-pointer "
                    />{" "}
                    Download
                  </button>
                </div>
              </div>
              <Table
                key={`agent-table-${agentSortBy}`}
                columns={agentColumns}
                data={filteredAgents}
                renderRow={renderAgentRow}
                sortableColumns={[0, 1, 2, 3, 4, 5]}
                columnKeys={[
                  "id",
                  "lastActive",
                  "totalClients",
                  "totalClientViews",
                  "newlyOnboarded",
                  "tours2D",
                  "vrTours",
                ]}
              />
            </div>
          )}

          {/* <div className="flex flex-col p-4 mb-6 bg-[#161F28] rounded-lg">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-white text-lg flex items-center gap-2">
                <span className="text-xl">⊖</span> Visits by Location
              </h2>
              <div className="flex items-center gap-2">
                <button className="bg-[#2E4051] text-white px-4 py-2 rounded border border-[#889DB2] text-sm">
                  Agent Map
                </button>
                <button className="bg-[#2E4051] text-white px-4 py-2 rounded border border-[#889DB2] text-sm">
                  Project Map
                </button>
                <select className="bg-[#2E4051] text-white px-4 py-2 rounded border border-[#889DB2] text-sm">
                  <option>Filter By: All Agents</option>
                </select>
              </div>
            </div>
            <div
              className="bg-[#2E4051] rounded-lg overflow-hidden flex items-center justify-center"
              style={{ height: "400px" }}
            >
              <div className="text-[#889DB2] text-center">
                <div className="text-4xl mb-2">🗺️</div>
                <div>Map View</div>
              </div>
            </div>
          </div> */}
          <div className="flex flex-col p-4 mb-6 bg-[#161F28] rounded-lg">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-white text-lg flex items-center gap-2">
                <Icon
                  onClick={showCustomDates && handleOpenPicker}
                  name="ic-circle-down"
                  className="w-5 h-5 text-white cursor-pointer "
                />{" "}
                Visits by Location
              </h2>
              <div className="flex items-center gap-2">
                {/* <button className="bg-[#2E4051] text-white px-4 py-2 rounded border border-[#889DB2] text-sm">
                  Agent Map
                </button> */}
                <button className="bg-[#2E4051] text-white px-4 py-2 rounded-lg  text-sm">
                  Project Map
                </button>
                {/* <select className="bg-[#2E4051] text-white px-4 py-2 rounded-lg text-sm">
                  <option>Filter By: All Agents</option>
                </select> */}
              </div>
            </div>
            <div
              className="bg-[#2E4051] rounded-lg overflow-hidden"
              style={{ height: "400px" }}
            >
              {projectLocations.length > 0 ? (
                <NewMap locations={projectLocations} />
              ) : (
                <div className="flex items-center justify-center h-full">
                  <div className="text-[#889DB2] text-center">
                    <div className="w-16 h-16 border-4 border-[#008564] border-t-transparent rounded-full animate-spin"></div>
                    <div>
                      {enrichedSessions.length > 0
                        ? "Loading map..."
                        : "No location data available"}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export { ClientAnalytics };
